// Auto-generated by pnpm i18n:snapshot — do not hand-edit.
import auth from './locales/en/auth.json';
import care from './locales/en/care.json';
import cbt_module from './locales/en/cbt_module.json';
import chat from './locales/en/chat.json';
import checkin from './locales/en/checkin.json';
import common from './locales/en/common.json';
import consent from './locales/en/consent.json';
import flow from './locales/en/flow.json';
import greeting from './locales/en/greeting.json';
import guided_conversations from './locales/en/guided_conversations.json';
import home from './locales/en/home.json';
import initial_review from './locales/en/initial_review.json';
import intake from './locales/en/intake.json';
import journey from './locales/en/journey.json';
import migration from './locales/en/migration.json';
import notifications from './locales/en/notifications.json';
import onboarding from './locales/en/onboarding.json';
import outreach from './locales/en/outreach.json';
import profile from './locales/en/profile.json';
import quit_date from './locales/en/quit_date.json';
import registration from './locales/en/registration.json';
import rewards from './locales/en/rewards.json';
import signup from './locales/en/signup.json';
import update_required from './locales/en/update_required.json';
import voice from './locales/en/voice.json';
import weekly_plan from './locales/en/weekly_plan.json';
import auth_es from './locales/es/auth.json';
import common_es from './locales/es/common.json';
import flow_es from './locales/es/flow.json';
import greeting_es from './locales/es/greeting.json';
import home_es from './locales/es/home.json';
import registration_es from './locales/es/registration.json';
import signup_es from './locales/es/signup.json';

export const snapshotResources = {
  en: {
    auth,
    care,
    cbt_module,
    chat,
    checkin,
    common,
    consent,
    flow,
    greeting,
    guided_conversations,
    home,
    initial_review,
    intake,
    journey,
    migration,
    notifications,
    onboarding,
    outreach,
    profile,
    quit_date,
    registration,
    rewards,
    signup,
    update_required,
    voice,
    weekly_plan,
  },
  es: {
    auth: auth_es,
    common: common_es,
    flow: flow_es,
    greeting: greeting_es,
    home: home_es,
    registration: registration_es,
    signup: signup_es,
  },
} as const;

export type SnapshotNamespace = keyof typeof snapshotResources.en;
export const NAMESPACES = Object.keys(snapshotResources.en) as SnapshotNamespace[];
